import stats from './stats'
import sishang from './sishang'
import serviceProcess from './service-process'

export default [...stats, ...sishang, ...serviceProcess]
